(function () {
  'use strict';

  // Widths used in product-thumbnail-src.liquid srcset
  const SRCSET_WIDTHS = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];

  // Matches Dawn's product page layout with medium (55%) media column
  const PRODUCT_IMAGE_SIZES = [
    '(min-width: 1200px) 715px',
    '(min-width: 990px) calc(55vw - 10rem)',
    '(min-width: 750px) calc(50vw - 6rem)',
    '100vw',
  ].join(', ');

  const dataEl = document.getElementById('variant-gallery-data');
  if (!dataEl) return;

  let galleryData;
  try {
    galleryData = JSON.parse(dataEl.textContent || '[]');
  } catch {
    return;
  }
  if (!galleryData.length) return;

  const preloaded = new Set();

  function preloadImage(url) {
    if (!url || preloaded.has(url)) return;
    preloaded.add(url);

    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = url;

    // Build full srcset so the browser picks the right size and caches it
    const srcset = SRCSET_WIDTHS.map(
      (w) => `${url.replace(/width=\d+/, `width=${w}`)} ${w}w`
    ).join(', ');
    link.setAttribute('imagesrcset', srcset);
    link.setAttribute('imagesizes', PRODUCT_IMAGE_SIZES);

    document.head.appendChild(link);
  }

  function preloadVariant(variantData, onlyFirst) {
    if (!variantData?.images?.length) return;
    const images = onlyFirst ? variantData.images.slice(0, 1) : variantData.images;
    images.forEach(preloadImage);
  }

  // Obergrenze für den Blind-Preload. Ohne Deckel lädt ein Produkt mit vielen
  // Farben zweistellig viele Vollbilder, bevor der Nutzer überhaupt eine
  // Variante angeklickt hat.
  const MAX_BLIND_PRELOADS = 8;

  // Der Blind-Preload konkurriert mit dem LCP-Bild um Bandbreite. Auf schmalen
  // Viewports (dort zieht `imagesizes` 100vw, also die volle Displaybreite pro
  // Bild) und auf langsamen bzw. Datensparen-Verbindungen überwiegt der
  // Schaden den Nutzen — dort läuft er gar nicht.
  function blindPreloadAllowed() {
    if (!window.matchMedia('(min-width: 750px)').matches) return false;

    const conn = navigator.connection;
    if (conn) {
      if (conn.saveData) return false;
      if (/2g/.test(conn.effectiveType || '')) return false;
    }

    return true;
  }

  // After page load: preload the first image of each unique first-option value
  function blindPreload() {
    if (!blindPreloadAllowed()) return;

    const seen = new Set();
    let budget = MAX_BLIND_PRELOADS;

    for (const variant of galleryData) {
      if (budget <= 0) break;
      if (!variant.images.length) continue;

      const key = variant.options[0];
      if (seen.has(key)) continue;

      seen.add(key);
      budget -= 1;
      preloadVariant(variant, true);
    }
  }

  // After variant selection: preload all remaining images of the new variant
  function setupVariantChangePreload() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
      if (!variant?.id) return;
      const variantData = galleryData.find((v) => v.id === variant.id);
      if (!variantData) return;
      // Small delay so the primary image fetch (triggered by DOM swap) goes first
      setTimeout(() => preloadVariant(variantData, false), 100);
    });
  }

  function init() {
    setupVariantChangePreload();

    // Erst nach dem load-Event und dann in einer Leerlaufphase starten. Ein
    // fixer Timer ab DOMContentLoaded traf sonst genau das Fenster, in dem das
    // LCP-Bild noch lud.
    function start() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(blindPreload, { timeout: 3000 });
      } else {
        setTimeout(blindPreload, 1500);
      }
    }

    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
